import { useEffect, useState } from "react";
import DefaultButton from "./DefaultButton";
import { useGuideTools } from "../utils/GuideContext";

export const GuideButton = ({ guide, ...props }) => {
    const guideTools = useGuideTools();
    const [showGuide, setShowGuide] = useState(false);

    useEffect(() => {
        if (guide && guideTools) {
            guideTools.isTourEligible(guide).then(result => {
                setShowGuide(result)
            })
        }
    }, [guideTools, guide])

    return showGuide && <DefaultButton kind="guide" onClick={e => { e.preventDefault(); e.stopPropagation(); guideTools.tryStartTour(guide); }} {...props}></DefaultButton>
}